import { render } from "./TerminationModal.vue?vue&type=template&id=ec2afc88"
import script from "./TerminationModal.vue?vue&type=script&lang=js"
export * from "./TerminationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__